import { useContext } from 'react';
import CompanyContext from '../context/companyContext';

/**
 * useCompanyContext is a convenience hook to access the company context
 */
export default function useCompanyContext() {
  return useContext(CompanyContext);
}
